import {Area} from "./area";
import {Unit} from "./unit";
import {Task} from "./task";
import {FormFile} from "./material";
import {Project} from "./project";
import {Comment} from "./comment";
import {HistoryItem} from "./historyItem";
import {DateType} from "./date-type";
import {PhaseGroup} from "./phase";

export class Room {
  id: number;
  publicId: string;
  name: string;
  subtitle: string;
  orderNumber: number;
  uniqNumber: number;
  areas: Area[] = [];
  version: number;
  templateVersion: number;
  templateName: string;
  usageAmount: number = 1;
  type: string
  attachmentsAmount: number;
  commentsAmount: number;
  unit: Unit;
  link: string;
  linkedTasks: Task[] =[];
  history: HistoryItem[] = [];
  hasAttachments: boolean;
  comments: Comment[] = [];
  files: FormFile[] =[];
  project: Project;
  statusProgress: number;
  notFinishedLinkedTasksAmount: number;
  paddingLeft: number;
  startDate: null;
  endDate: null;
  effStartDate: null;
  effEndDate: null;
  actualStartDate: null;
  actualEndDate: null;
  dateType: DateType;
  phaseGroup: PhaseGroup;
}

export type EntityKind = 'ROOM' | 'PHASE';

export enum FormMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  TEMPLATE_EDIT = 'TEMPLATE_EDIT',
  BASED_ON_TEMPLATE_EDIT = 'BASED_ON_TEMPLATE_EDIT',
  BASED_ON_TEMPLATE_CREATE = 'BASED_ON_TEMPLATE_CREATE'
}

